var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"space-y-2"},_vm._l((_vm.notes),function(note){return _c('NoteListItem',{key:note.id,attrs:{"note":note},on:{"update":_vm.fetchNotes,"destroy":function($event){return _vm.$emit('destroy')}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }